import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Icon } from '@node-space/ui-components'
import { useProfileContext } from 'hooks/context/useProfileContext'
import { useTwoFAContext } from 'hooks/useTwoFAContext'

interface ApiKeyHeaderCreateButtonProps {
  onSheetOpen: () => void
}

const ApiKeyHeaderCreateButton = ({ onSheetOpen }: ApiKeyHeaderCreateButtonProps) => {
  const { t } = useTranslation()
  const { viewOnly } = useProfileContext()
  const { twoFactorEnabled, setShowTwoFAModal } = useTwoFAContext()

  const generateButtonAction = () => {
    if (twoFactorEnabled) {
      onSheetOpen()
    } else {
      setShowTwoFAModal(true)
    }
  }
  return (
    <Button
      disabled={viewOnly}
      onClick={() => generateButtonAction()}
      testId={'generate-api-key'}
      iconElement={<Icon name="Plus" />}
    >
      {t('manageApiKeys.generateAPIKeyBtn')}
    </Button>
  )
}

export default React.memo(ApiKeyHeaderCreateButton)
